module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "courses-container"
  }, [_c('div', [_c('top-bar', {
    attrs: {
      "teachers": _vm.school_teachers
    },
    on: {
      "filters": _vm.searchAndFilters,
      "admin-portal-filter-changed": _vm.resetFilters
    }
  })], 1), _vm._v(" "), _c('div', [_c('courses-table', {
    attrs: {
      "coursesList": _vm.courses,
      "teachers": _vm.school_teachers,
      "loading": _vm.loading,
      "schoolCoursesCount": _vm.schoolCoursesCount
    },
    on: {
      "scroll-on-table": function($event) {
        return _vm.handleScroll(_vm.page_number)
      },
      "updateNumberOfCourses": _vm.updateNumberOfCourses
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row w-100 center-xs"
  }, [(_vm.loading_table_body) ? _c('div', [_c('pl-spinner', {
    staticClass: "x5"
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-42a9be64!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/courses/adminPortalCourses.vue
// module id = 2088
// module chunks = 61